let files = []
const requireModule = require.context('@/configurations/templates/columns', true, /\.js$/i, 'sync')

requireModule.keys()
  .filter(fileName => fileName !== './index.js')
  .forEach(fileName => files = [...files, ...requireModule(fileName).default])

export default files
